import SectionHeading from "./SectionHeading";
import { people } from "@/mocks/people";

function heatLevel(heat: number) {
  if (heat >= 85) return { label: "持续发酵", color: "text-primary-600" };
  if (heat >= 75) return { label: "讨论中", color: "text-accent-700" };
  return { label: "趋于平稳", color: "text-secondary-700" };
}

export default function People() {
  return (
    <section id="people" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="PROFILE · 人物档案"
        title="最近被讨论最多的人物"
        desc="按当前争议指数排序，档案只做公开信息的归集与整理，标注关联话题数量，不代表对个人的评价与定性。"
      />

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {people.map((person) => {
          const level = heatLevel(person.heat);
          return (
            <article
              key={person.id}
              className="bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-xl font-bold">
                  {person.initial}
                </span>
                <div className="min-w-0">
                  <h3 className="text-base font-bold text-foreground-950">{person.name}</h3>
                  <p className="text-xs text-foreground-500">{person.role}</p>
                </div>
                <span className={`ml-auto text-xs font-medium ${level.color}`}>{level.label}</span>
              </div>

              <div className="mt-4 flex flex-wrap gap-2">
                {person.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs text-secondary-900 bg-secondary-100 px-2 py-0.5 rounded-md"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                {person.desc}
              </p>

              <div className="mt-4">
                <div className="flex items-center justify-between text-xs text-foreground-500 mb-1.5">
                  <span>争议指数</span>
                  <span className="font-medium text-foreground-800">{person.heat}</span>
                </div>
                <div className="h-1.5 w-full bg-background-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary-500 rounded-full"
                    style={{ width: `${person.heat}%` }}
                  />
                </div>
              </div>

              <div className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-price-tag-3-line" />
                关联话题 {person.topics} 个
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}